<div class="bc-email-compose-more-actions" [@slideInFromBottomAnimation]>
  <svg-icon icon="x" (click)="onTogglePanelClick()" class="icon-close" id="toggle-email-compose-more-actions"></svg-icon>

  <div class="container-fluid">
    <div class="control-panel-groups">
      <div class="control-panel-group control-panel-group-send">
        <button
          id="email-compose-send-message-button"
          (click)="onSendMessageClick()"
          [disabled]="isSendButtonDisabled"
          class="btn btn-dark bc-footer-button"
          [attr.data-automation-id]="'compose-email-send-button'">
          <span>{{ 'emailWorkWidget.sendMessage' | translate }}</span>
        </button>
      </div>
      <div class="control-panel-group control-panel-group-action">
        <a (click)="onCancelMessageClick()" class="btn btn-light" id="email-compose-cancel-message-button">
          <span>{{ 'emailWorkWidget.cancel' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
